import apiClient from "./apiClient";

export const parametri = () => apiClient.get("/parametri");

export const updateParametri = (formData) =>
    apiClient.post("/update-parametri", formData);